function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { LocaleContext } from '../locale-provider/LocaleProvider';
import defaultLocaleData from '../locale-provider/locale/zh_CN';

var LocaleReceiverWrapper = function LocaleReceiverWrapper(name, defaultLocale) {
  return function InnerWrapper(WrappedComponent) {
    var LocaleReceiver = function LocaleReceiver(props) {
      return React.createElement(LocaleContext.Consumer, null, function (locale) {
        var globalLocale = locale.locale ? locale : defaultLocale || defaultLocaleData;
        var componentLocale = globalLocale[name || WrappedComponent.name];
        var localeCode = globalLocale.locale;

        var forwardedRef = props.forwardedRef,
            rest = _objectWithoutProperties(props, ["forwardedRef"]);

        return React.createElement(WrappedComponent, _extends({}, rest, {
          ref: forwardedRef,
          locale: componentLocale,
          localeCode: localeCode
        }));
      });
    };

    var forwardRef = function forwardRef(props, ref) {
      return React.createElement(LocaleReceiver, _extends({}, props, {
        forwardedRef: ref
      }));
    };

    var LocaleReceiverWithRef = React.forwardRef(forwardRef);
    hoistNonReactStatic(LocaleReceiverWithRef, WrappedComponent);
    return LocaleReceiverWithRef;
  };
};

export default LocaleReceiverWrapper;